import { User } from './../models/user.model';
import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Role, Permission } from '../models';
import { NgxPermissionsService } from 'ngx-permissions';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { UserPermissionService } from './user-permission.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService implements OnInit {
  private userRoles: Role[] = [];
  private userPermissions: Permission[] = [];
  private allPermissions: Permission[] = [];
  // private currentUser: User = new User();
  private permissions: string[] = [];
  constructor(
    private http: HttpClient, 
    private permissionsService: NgxPermissionsService, 
    private router: Router,
    private userPermissionService: UserPermissionService
  ) {}

  ngOnInit() {}

  logIn(loginInfo) {
    return this.http.post<any>(environment.apiUrl + 'account/login', loginInfo, this.generateHeaders());
  }
  logout() {
    this.permissionsService.flushPermissions();
    // Clear cached user pages on logout
    this.userPermissionService.clearUserPages();
    this.router.navigate(['/auth']);
  }
  loadUserData() {
    // this.http.get(environment.apiUrl + '/api/Users/logged', this.generateHeaders()).subscribe((Response: User) => {
    //   //   this.permissions = Response.permissions;
    //   //   this.initNgxPermissions(Response.permissions);
    //   //   this.currentUser.next(Response);
    // });
  }

  initNgxPermissions(permissions: string[]) {
    this.permissionsService.loadPermissions(permissions);
  }

  getData(url: string) {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    httpHeaders.set('Authorization', 'Bearer ' + this.getToken());

    return this.http.get(url, { headers: httpHeaders });
  }

  isAuthenticated(): boolean {
    const sessionStorage = this.getToken();
    return sessionStorage == null ? false : true;
  }

  isAuthorized(url: string): boolean {
    return this.isAuthenticated() && this.userHasPermission(url); // ToDo change logic to check url required permission
  }

  userHasPermission(name: string) {
    return this.permissions.find((x) => x.trim().toLowerCase() === name.trim().toLowerCase()) !== null;
  }

  getToken() {
    return sessionStorage.getItem('serviceAdmintoken');
  }
  setToken(token: string) {
    sessionStorage.removeItem('serviceAdmintoken');
    sessionStorage.setItem('serviceAdmintoken', token);
    
    this.userPermissionService.loadUserPages().subscribe();
  }
  private generateHeaders() {
    let _headers = {};
    if (this.isAuthenticated()) {
      const token = 'Bearer ' + this.getToken();
      _headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: token });
    } else {
      _headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    }
    return {
      headers: _headers,
    };
  }
}
